import React, { useEffect, useState } from 'react';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Pagination from 'components/Pagination';
import Modal from '../../../components/Modal/NotificationModal';
import ToggleSwitch from '../../../components/ToggleSwitch/ToggleSwitch';
import {
  Modal as ReactstrapModal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import FormTooltip from 'components/Inputs/FormTooltip';

import QueueService from '../service';

import {
  Input,
  Container,
  Row as Row,
  Card,
  CardHeader,
  Button,
  CardBody,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormGroup,
  Label
} from 'reactstrap';

import {
  icon_column_style,
  individual_column_style,
  individual_icon_header_style,
  individual_header_style
} from '../../../assets/styles/table_custom_style';
import ReactLoader from 'components/Loader';
import { StrategyChat } from '../form/assets';
import { getDescriptionStrategyChat } from '../helpers/getDescriptionStrategyChat';
import { FlexController } from 'components/FlexControllerInput';
import { useForm } from 'react-hook-form';
import { useGeneralQueueConfig } from '../../../hooks/useGeneralQueueConfig';
import { FlexControllerV2 } from 'components/FlexControllerInput/V2';

const QueueList = () => {
  const [queues, setQueues] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showDisable, setShowDisable] = useState(false);
  const [searchQueues, setSearchQueues] = useState();
  const [isConfigModalOpen, setIsConfigModalOpen] = useState(false);

  const [sortField, setSortField] = useState('name');
  const [sortOrder, setSortOrder] = useState('asc');

  useEffect(() => {
    getQueues();
  }, [sortField, sortOrder]);

  const getQueues = (selectedPage = 1, search = '') => {
    setLoading(true);
    QueueService.getAllSeachQueue(
      selectedPage,
      10,
      search,
      showDisable,
      {},
      sortField,
      sortOrder
    )
      .then((response) => {
        const queueList = response.data.data;
        const quantity = response.data.totalRegisters;

        setQueues(queueList);
        setQuantity(quantity);
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err.response.data.message || 'Erro ao listar filas!', {
          autoClose: 3000,
          closeOnClick: true
        });
        setLoading(false);
      });
  };

  useEffect(getQueues, [showDisable]);

  const toggleDisable = (id, disable) => {
    if (!disable) {
      disableQueue(id);
    } else {
      recoveryQueue(id);
    }
  };

  const disableQueue = (id) => {
    if (!window.confirm('Tem certeza que deseja desabilitar a fila?')) return;
    QueueService.delete(id)
      .then(() => {
        toast.info('Fila desabilitada com sucesso!', {
          autoClose: 3000,
          closeOnClick: true
        });
        getQueues();
        setActivePage(1);
      })
      .catch((err) => {
        toast.error(err.response.data.message || 'Ops algo errado aconteceu!', {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const recoveryQueue = (id) => {
    QueueService.recovery(id)
      .then(() => {
        toast.info('Fila recuperada com sucesso!', {
          autoClose: 3000,
          closeOnClick: true
        });
        getQueues(activePage);
      })
      .catch((err) => {
        toast.error(err.response.data.message || 'Ops algo errado aconteceu!', {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const getQueuesSearch = (event, selectedPage = 1) => {
    setSearchQueues(event.target.value);
    if (searchQueues) {
      getQueues(selectedPage, event.target.value);
    }
  };

  const handlePageChange = (page) => {
    setActivePage(page);
    getQueues(page);
  };

  const handleShowDisableds = (value) => {
    setShowDisable(value);
    if (value === false) setActivePage(1);
  };

  const ConfigurationModal = () => {
    const { limitationOptions, config, update, isLoading } =
      useGeneralQueueConfig();

    const { errors, setValue, control, handleSubmit, reset } = useForm({
      defaultValues: {
        typeOfLimitation: limitationOptions[0],
        monitoringReloadTime: ''
      }
    });

    // Sincroniza o form quando os dados do hook chegam
    useEffect(() => {
      if (config) {
        reset({
          typeOfLimitation: config.typeOfLimitation,
          monitoringReloadTime: config.monitoringReloadTime
        });
      }
    }, [config, reset]);

    const onSubmit = async (data) => {
      const success = await update(data);
      if (success) {
        setIsConfigModalOpen(false);
      }
    };

    return (
      <ReactstrapModal
        isOpen={isConfigModalOpen}
        toggle={() => setIsConfigModalOpen(!isConfigModalOpen)}
        className="modal-dialog-centered"
      >
        <ModalHeader toggle={() => setIsConfigModalOpen(false)}>
          Configurações gerais de fila
        </ModalHeader>
        <ModalBody>
          {isLoading ? (
            <ReactLoader />
          ) : (
            <Col className="p-0">
              <div className="mb-3">
                <FlexController
                  type="selectable"
                  name="typeOfLimitation"
                  textoDoLabel="Modo de limitação de quantidade de conversas"
                  options={limitationOptions}
                  valueController={setValue}
                  isClearable={false}
                  errors={errors}
                  control={control}
                />
              </div>

              <FlexControllerV2
                type="number"
                name="monitoringReloadTime"
                placeholder="Tempo em minutos"
                label="Tempo de recarregamento automático do monitoramento chat e telefonia (min)"
                errors={errors}
                control={control}
                step="1"
                rules={{
                  min: {
                    value: 0,
                    message: 'O valor deve ser maior ou igual a 0'
                  },
                  validate: (value) => {
                    // Se vazio, passa (pois não é required)
                    if (value === '' || value === null || value === undefined)
                      return true;
                    // Verifica se é inteiro
                    return (
                      Number.isInteger(Number(value)) ||
                      'O valor deve ser um número inteiro'
                    );
                  }
                }}
                title="Define de quantos em quantos minutos as telas de monitoramento de filas (chat e telefonia) serão recarregadas automáticamente. Defina como 0 para desativar essa função."
              />
            </Col>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setIsConfigModalOpen(false)}>
            Cancelar
          </Button>
          <Button color="primary" onClick={handleSubmit(onSubmit)}>
            Salvar
          </Button>
        </ModalFooter>
      </ReactstrapModal>
    );
  };

  return (
    <>
      <SimpleHeader
        setCreate="/admin/queue/form"
        name="Form validation"
        parentName="Forms"
      >
        <Button onClick={() => setIsConfigModalOpen(true)}>
          <i className="fas fa-cog mr-2" />
          Configurações gerais
        </Button>
      </SimpleHeader>
      <Container className="mt--6" fluid>
        <Row className="mt-3 mx-2">
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3>Fila</h3>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="8">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fas fa-search" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Fila"
                          type="text"
                          onChange={(event) => getQueuesSearch(event)}
                        />
                      </InputGroup>
                    </Col>
                    <Col md="4" className="text-right mt-2">
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            checked={showDisable}
                            onChange={() => handleShowDisableds(!showDisable)}
                          />
                          <span className="form-check-sign" />
                          <span>Mostrar desabilitadas</span>
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
                <ToolkitProvider
                  data={queues}
                  keyField="id"
                  columns={[
                    {
                      dataField: 'name',
                      text: 'Nome',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style,
                      onSort: (column, order) => {
                        setSortField('name');
                        setSortOrder(order);
                      }
                    },
                    {
                      dataField: 'strategy',
                      text: 'Estratégia',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style,
                      onSort: (column, order) => {
                        setSortField('strategy');
                        setSortOrder(order);
                      }
                    },
                    {
                      dataField: 'strategy_chat',
                      text: 'Estratégia do Chat',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style,
                      onSort: (column, order) => {
                        setSortField('strategy_chat');
                        setSortOrder(order);
                      },
                      formatter: (_, row) => {
                        if (!row || !StrategyChat) return '';
                        return getDescriptionStrategyChat(row.strategy_chat);
                      }
                    },
                    {
                      dataField: '',
                      text: 'Canal',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style,
                      onSort: (column, order) => {
                        setSortField('is_chat');
                        setSortOrder(order);
                      },
                      formatter: (_, row) => {
                        if (!row) return '';
                        if (row?.is_chat && row?.is_telephony)
                          return 'Chat e Telefonia';
                        if (row?.is_chat) return 'Chat';
                        if (row?.is_telephony) return 'Telefonia';
                      }
                    },
                    {
                      dataField: 'max_chat_per_user',
                      text: 'Limite de distribuição',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style,
                      onSort: (column, order) => {
                        setSortField('max_chat_per_user');
                        setSortOrder(order);
                      },
                      formatter: (cell) => (
                        <div style={{ textAlign: 'center', width: '100%' }}>
                          {cell}
                        </div>
                      )
                    },
                    {
                      dataField: 'configs',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Configurações',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Modal name={row.name}>
                            <p>
                              <strong>Tempo de Toque: </strong>
                              {row.timeout ? 'sim' : 'Não'}
                            </p>
                            <p>
                              <strong>Anúncio Periódico: </strong>
                              {row.periodic_announce}
                            </p>
                            <p>
                              <strong>Freq. Anúncio Periódico: </strong>
                              {row.periodic_announce_frequency}
                            </p>
                            <p>
                              <strong>Pausa Automática: </strong>
                              {row.autopause === true ? 'Sim' : 'Não'}
                            </p>
                            <p>
                              <strong>Tocar quando ocupado: </strong>
                              {row.ringinuse === true ? 'Sim' : 'Não'}
                            </p>
                            <p>
                              <strong>Música de Espera: </strong>
                              {row.musiconhold}
                            </p>
                            <p>
                              <strong>Tempo entre Chamadas: </strong>
                              {row.wrapuptime}
                            </p>
                            <p>
                              <strong>Setor: </strong>
                              {row.centrodecusto.name}
                            </p>
                            <hr />
                            <p>
                              <strong>Configurações de Chat</strong>
                            </p>
                            <p>
                              <strong>Estratégia: </strong>
                              {getDescriptionStrategyChat(row.strategy_chat)}
                            </p>
                            <p>
                              <strong>Máximo de chat por agente: </strong>
                              {row.max_chat_per_user}
                            </p>
                            <p>
                              <strong>
                                Considera chats ativos para distribuição:
                              </strong>
                              {row.active_chat_in_chat_distribution
                                ? 'Sim'
                                : 'Não'}
                            </p>
                          </Modal>
                        );
                      }
                    },
                    {
                      dataField: 'color',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Cor',
                      // eslint-disable-next-line react/display-name
                      formatter: (rowContent, row) => {
                        return (
                          <div
                            style={{
                              marginLeft: '45%',
                              width: '15px',
                              height: '15px',
                              borderRadius: '50%',
                              backgroundColor: `${row.color}`
                            }}
                          />
                        );
                      }
                    },
                    {
                      dataField: 'disable',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Habilitar / Desabilitar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <ToggleSwitch
                            checked={!row.disable}
                            id={row.name}
                            onChange={() => toggleDisable(row.id, row.disable)}
                          />
                        );
                      }
                    },
                    {
                      dataField: 'edit',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Editar',
                      // eslint-disable-next-line react/display-name
                      formatter: (rowContent, row) => {
                        return (
                          <Link to={'/admin/queue/form/' + row.id}>
                            <Button color="info" size="sm">
                              <li className="fas fa-user-edit"></li>
                            </Button>
                          </Link>
                        );
                      }
                    }
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      {loading ? (
                        <Row className="justify-content-md-center">
                          <ReactLoader />
                        </Row>
                      ) : (
                        <BootstrapTable
                          {...props.baseProps}
                          bootstrap4={true}
                          bordered={false}
                          classes="align-items-center"
                          sort={{
                            dataField: sortField,
                            order: sortOrder?.toLowerCase()
                          }}
                        />
                      )}
                    </div>
                  )}
                </ToolkitProvider>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={quantity}
                  onChange={handlePageChange.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>
      <ConfigurationModal />
    </>
  );
};

export default QueueList;
